// 参加者用サイドパネル (M4)。8 ボタンの TA 機能を提供する。
// M7 で検索入力欄を追加予定。

import { type ReactElement } from 'react';
import { DEFAULT_LOCALE, t } from '@solo-webinar-copilot/i18n';
import { ButtonGrid } from './ButtonGrid.tsx';
import { SearchBox } from './SearchBox.tsx';
import type { AppContext } from '../lib/zoom-sdk.ts';

export interface ParticipantPanelProps {
  ctx: AppContext;
}

export function ParticipantPanel({ ctx }: ParticipantPanelProps): ReactElement {
  const locale = DEFAULT_LOCALE;
  return (
    <div data-testid="participant-panel">
      <header>
        <h1>{t('in_client.participant.title', locale)}</h1>
        {ctx.isMock ? <small data-testid="mock-badge">[MOCK]</small> : null}
      </header>
      <ButtonGrid ctx={ctx} locale={locale} />
      <SearchBox ctx={ctx} locale={locale} />
    </div>
  );
}
